export const TestHooks = {
	IntakeButton: 'intake-button',
	IntakeDropdownButton: 'intake-dropdown-button',
} as const;
